/**
 * Estimate reading time from markdown content (words / 200 WPM).
 */
export const getReadingTime = (content, wordsPerMinute = 200) => {
  if (!content) return 1;
  const wordCount = content.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(wordCount / wordsPerMinute));
};

export const isSvgImage = (url) => typeof url === 'string' && url.toLowerCase().endsWith('.svg');
